
import payroll from '@/http/requests/payroll'

export default {
  fetchPayrollList({ commit }, data) {
    return new Promise((resolve, reject) => {
      payroll.list(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_PAYROLL_LIST', response.data.data)
          } else {
            commit('SET_PAYROLL_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
